module.exports = __webpack_public_path__ + "img/herby-1.7dea756f.png";